import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import mapProductIdPrice from './mapProductIdPrice';
import ProductIdPrice from './ProductIdPrice';

const MaxProductIdsCount = 50;

export interface Result {
	items: ProductIdPrice[];
}

export default function findProductPrices(
	client: ApiClient,
	currency: string | null,
	productIds: string[]
): Promise<Result> {
	const url = parseTemplate('products-prices{?currency,productIds}');

	const batchesCount = Math.ceil(productIds.length / MaxProductIdsCount);
	const requests = Array(batchesCount)
		.fill(null)
		.map((foo, i) => {
			const batchProductIds = productIds.slice(i * MaxProductIdsCount, i * MaxProductIdsCount + MaxProductIdsCount);

			return client
				.fetch(url.expand({ currency, productIds: batchProductIds.join(',') }))
				.then((response) => response.json());
		});

	return Promise.all(requests).then((responses) => ({
		items: responses.reduce((items, response) => [...items, ...response.items.map(mapProductIdPrice)], []),
	}));
}
